import { Drawer } from 'antd';
import styled from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  position: relative;
  height: 100vh;
  overflow: auto;
  padding: 10px 0;

  .ant-drawer-header {
    display: none;
  }

  .ant-drawer-body {
    padding: 0 30px 10px;
  }
`;

export const FooterWrapper = styled.div`
  text-align: right;
  margin: 15px 10px;

  button {
    margin-right: 10px;
  }
`;
